/* Sticky purchase bar for long configurators: shows the running subtotal and an Add to cart button while the real button is off screen. */
(function () {
  var panel = document.querySelector('[data-a1-options]');
  if (!panel) return;
  var form = panel.closest('form');
  var btn = form && form.querySelector('[name="add"]');
  var total = panel.querySelector('[data-a1-total]');
  if (!btn || !total) return;
  var bar = document.createElement('div');
  bar.className = 'a1-buybar';
  bar.hidden = true;
  bar.innerHTML = '<div class="a1-buybar__total" aria-live="polite"></div><button type="button" class="a1-buybar__btn">Add to cart</button>';
  document.body.appendChild(bar);
  var label = bar.querySelector('.a1-buybar__total');
  function sync() {
    var m = (total.textContent || '').match(/\$[\d,]+\.\d\d/);
    label.textContent = m ? 'Subtotal ' + m[0] : '';
  }
  new MutationObserver(sync).observe(total, { childList: true, characterData: true, subtree: true });
  sync();
  bar.querySelector('button').addEventListener('click', function () { btn.click(); });
  var btnVisible = false, panelVisible = false;
  function update() { bar.hidden = !(panelVisible && !btnVisible && window.scrollY > 400); }
  window.addEventListener('scroll', update, { passive: true });
  new IntersectionObserver(function (e) { btnVisible = e[0].isIntersecting; update(); }).observe(btn);
  new IntersectionObserver(function (e) { panelVisible = e[0].isIntersecting; update(); }, { threshold: 0.05 }).observe(panel);
})();
